import * as swcHelpers from '@swc/helpers';
import { DataLayer } from '@grandvisionhq/analytics';
import { isSubscriptionPurchase } from '@grandvisionhq/fun-products';

const SUBSCRIPTION_EVENT = 'subscription_interaction';
const SUBSCRIPTION_FEATURE = 'subscription';
const SINGLE_PURCHASE_FEATURE = 'one-time';
const pushDeliveryIntervalSelectionEvent = (deliveryInterval)=>{
    DataLayer.pushEvent({
        event: SUBSCRIPTION_EVENT,
        site_feature: SUBSCRIPTION_FEATURE,
        interaction_type: 'choose_delivery_interval',
        delivery_interval: deliveryInterval
    });
};
const pushPurchaseTypeSelectionEvent = (purchaseType)=>{
    const interactionType = isSubscriptionPurchase(purchaseType) ? 'choose_subscription' : 'choose_single_purchase';
    DataLayer.pushEvent({
        event: SUBSCRIPTION_EVENT,
        site_feature: SUBSCRIPTION_FEATURE,
        interaction_type: interactionType
    });
};
const pushQuantitySelectionEvent = ({ quantity , purchaseType , isAvailableForSubscription , eyeSide  })=>{
    const siteFeature = isAvailableForSubscription ? SUBSCRIPTION_FEATURE : SINGLE_PURCHASE_FEATURE;
    DataLayer.pushEvent(swcHelpers.objectSpread({
        event: SUBSCRIPTION_EVENT,
        site_feature: siteFeature,
        purchase_type: purchaseType,
        interaction_type: 'choose_quantity'
    }, !!eyeSide ? {
        eyeSide
    } : {}, {
        quantity
    }));
};

export { pushDeliveryIntervalSelectionEvent, pushPurchaseTypeSelectionEvent, pushQuantitySelectionEvent };
//# sourceMappingURL=subscription.js.map
